import {TransferFormat, TransferMode} from '@service-and-repairs/dms-api';
import {ServiceContractTransferMethod} from '../../core/configuration/interfaces/ServiceContractTransferMethod';
import {DcomDmsSettings} from './dcom-dms-settings';
import {EtkDmsSettings} from './etk-dms-settings';
import {AwpDmsInterfaceConfig} from "./awp-dms-interface-config";

export class DmsSettings {
  transferMode: TransferMode = TransferMode.Undefined;
  transferFormat: TransferFormat = TransferFormat.Unknown;
  transferFileStorageLocation: string = undefined;
  lockJobsAfterTransfer: boolean = false;
  lockJobsAfterTransferAsPreOrder: boolean = false;
  serviceContractTransferMethod: ServiceContractTransferMethod = undefined;
  serviceContractTransferNumber: string = undefined;
  awp: AwpDmsInterfaceConfig = new AwpDmsInterfaceConfig();
  isAutomaticPriceRequestEnabled: boolean = false;
  dcom: DcomDmsSettings = new DcomDmsSettings();
  etk: EtkDmsSettings = new EtkDmsSettings();
}
